import axios from "axios";
import { signIn } from "./router/constant";
import { toast } from "react-toastify";
import { clearExistingToken } from "./helper";

const getDomain = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  // Construct the base URL with protocol and domain
  let baseURL = `${url.protocol}//${url.hostname}/api`;
  if (url.hostname === "localhost") {
    baseURL = process.env.REACT_APP_BASE_URL;
  }
  return baseURL;
};

// const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const api = axios.create({
  baseURL: getDomain(),
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] =
      config.headers["Content-Type"] || "multipart/form-data";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      window.location.pathname = signIn;
      clearExistingToken();
      toast.warning("Session expired! Redirecting to login...");
      return Promise.resolve();
    }

    return Promise.reject(error);
  }
);

export const api_strapi = axios.create({
  baseURL: process.env.REACT_APP_STRIPI_URL,
});

export default api;
